module.exports = __webpack_public_path__ + "img/icon_document.9efad555.svg";